export default "__VITE_ASSET__vrKfLgF0__"